import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=5903dfcc&scoped=true&"
import script from "./CommonLayout.vue?vue&type=script&lang=js&"
export * from "./CommonLayout.vue?vue&type=script&lang=js&"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&id=5903dfcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903dfcc",
  null
  
)

export default component.exports